import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SettingsProvider } from './context/SettingsContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <CurrencyProvider>
        <SettingsProvider>
          <App />
        </SettingsProvider>
      </CurrencyProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
